import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';
import './Navbar.css';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1280);
  const isEnglish = location.pathname.startsWith('/en');
  
  const getPath = (path) => {
    if (isEnglish) {
      if (path === '/') return '/en';
      // Map Turkish paths to English paths
      const pathMap = {
        '/hakkinda': '/en/about',
        '/projeler': '/en/projects',
        '/iletisim': '/en/contact',
        '/duyurular': '/en/announcements',
        '/uygulamalar': '/en/applications',
        '/destek': '/en/support',
        '/progenxakademi': '/en/academy',
        '/cerez-politikasi': '/en/cookie-policy'
      };
      return pathMap[path] || '/en' + path;
    }
    return path;
  };
  
  const getMenuText = (text) => {
    if (isEnglish) {
      const translations = {
        'ANA SAYFA': 'HOME',
        'HAKKINDA': 'ABOUT',
        'PROJELER': 'PROJECTS',
        'İLETİŞİM': 'CONTACT',
        'DUYURULAR': 'ANNOUNCEMENTS',
        'UYGULAMALAR': 'APPLICATIONS',
        'DESTEK': 'SUPPORT',
        'AKADEMİ': 'ACADEMY',
        'UYGULAMA': 'APP'
      };
      return translations[text] || text;
    }
    return text;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const menuItems = [
    { path: "/", text: "ANA SAYFA" },
    { path: "/hakkinda", text: "HAKKINDA" },
    { path: "/projeler", text: "PROJELER" },
    { path: "/iletisim", text: "İLETİŞİM" },
    { path: "/duyurular", text: "DUYURULAR" },
    { path: "/uygulamalar", text: "UYGULAMALAR" },
    { path: "/destek", text: "DESTEK" },
    { path: "/progenxakademi", text: "AKADEMİ" }
    // { path: "/giris", text: "GİRİŞ" } // İleride kullanılacak
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to={isEnglish ? '/en' : '/'} className="navbar-logo">
          <img src={logo} alt="ProgenX Logo" />
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </div>
        
        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          {menuItems.map((item, index) => (
            <li className="nav-item" style={{"--item-index": index}} key={index}>
              <Link to={getPath(item.path)} className="nav-link" onClick={() => setMenuOpen(false)}>
                {getMenuText(item.text)}
              </Link>
            </li>
          ))}
          <li className="nav-item dropdown" style={{"--item-index": menuItems.length}}>
            <button 
              className={`nav-link dropdown-toggle ${dropdownOpen ? 'dropdown-open' : 'dropdown-closed'}`}
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown();
              }}
            >
              {getMenuText('UYGULAMA')} <FontAwesomeIcon icon={faChevronDown} className="dropdown-chevron" />
            </button>
            <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
              <li>
                <a href="https://app.progenxacademy.com/" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   className="dropdown-item"
                   onClick={() => {setMenuOpen(false); setDropdownOpen(false);}}>
                  {isEnglish ? 'Web App Login' : 'Web Uygulaması Giriş'}
                </a>
              </li>
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.ProgenxAcademy.progenx" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   className="dropdown-item"
                   onClick={() => {setMenuOpen(false); setDropdownOpen(false);}}>
                  {isEnglish ? 'Download Android App' : 'Android Uygulama İndir'}
                </a>
              </li>
              <li>
                <a href="https://apps.apple.com/tr/app/progenx/id6744415621?l=tr" 
                   target="_blank"
                   rel="noopener noreferrer"
                   className="dropdown-item"
                   onClick={() => {setMenuOpen(false); setDropdownOpen(false);}}>
                  {isEnglish ? 'Download iOS App' : 'iOS Uygulama İndir'}
                </a>
              </li>
            </ul>
          </li>
          <li className="nav-item language-switcher-item" style={{"--item-index": menuItems.length + 1}}>
            <LanguageSwitcher onLanguageChange={() => setMenuOpen(false)} />
          </li>
        </ul>
        
        <div className="navbar-desktop-language-switcher">
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 